import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RecuperacaoFluxoService } from '@modules/auth/services/recuperacao-fluxo.service';

export const exigeEmailGuard: CanActivateFn = () => {
  const fluxo = inject(RecuperacaoFluxoService);
  const router = inject(Router);
  return fluxo.email() ? true : router.createUrlTree(['/esqueci-senha']);
};

export const exigeResetTokenGuard: CanActivateFn = () => {
  const fluxo = inject(RecuperacaoFluxoService);
  const router = inject(Router);
  return fluxo.resetToken() ? true : router.createUrlTree(['/esqueci-senha']);
};
